import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=0b74f948&"
import script from "./IconLink.js?vue&type=script&lang=js&"
export * from "./IconLink.js?vue&type=script&lang=js&"
import style0 from "./IconLink.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports